<script>
export default {
    name: "UiCarouselSlide",
}
</script>

<template>
    <div class="carousel-slide">
        <slot></slot>
    </div>
</template>